<template>
	<div class="sidebar-text-input" ref="sidebarTextInput">
		<div v-for="(input, index) in data" :key="input.key" class="row" >
			<div class="col-12">
				<erco-text-input class="_input"
				                 :label="input.label"
				                 :text="input.text"
				                 @input="handleInput(index, $event)"
				                 inputType="auto"
				                 :resetable="true"
				                 :charlength="input.charlength"
				                 @reset="handleReset(index)">
				</erco-text-input>
			</div>
		</div>
	</div>
</template>

<script>
	import ErcoTextInput from '@/components/molecules/ErcoTextInput';

	function focusFirstElement() {
		const containerNode = this.$refs.sidebarTextInput;

		if (!containerNode) {
			return;
		}

		const firstInputNode = containerNode.querySelector('input');

		if (firstInputNode) {
			firstInputNode.focus();
		}
	}

	export default {
		name: 'ErcoSidebarTextInputMolecule',

		props: {
			data: {
				type: Array,
				default: () => [],
			},
		},

		mounted: focusFirstElement,
		updated: focusFirstElement,

		methods: {
			handleInput(index, newValue) {
				const key = this.data[index].key;

				const newSidebarContext = Object.assign({}, this.$store.state.sidebar.context);
				newSidebarContext.value[key] = newValue;

				this.$store.dispatch('updateSidebar', {
					context: newSidebarContext,
				});
			},

			handleReset(index) {
				this.handleInput(index, '');
			},
		},

		components: {
			ErcoTextInput,
		},
	};
</script>

<style lang="scss">

	.sidebar-text-input {
		padding: 0.5rem;
		padding-top: 1.5rem;
	}

</style>



// WEBPACK FOOTER //
// TextInput.vue?16565e94